export const LoginMode = {
  /** Signs in to the app: tokens in memory, then a return to the page the user wanted. */
  APP: 'app',
  /** Signs in for an MCP authorization transaction: the front's /oauth/* endpoints, then the consent step. */
  AUTHORIZE: 'authorize'
} as const;
export type LoginModeType = (typeof LoginMode)[keyof typeof LoginMode];
